import gql from 'graphql-tag';
export default gql`
subscription tableOrderUpdatedV2( $siteId: String!){
    tableOrderUpdatedV2(siteId: $siteId){
      id
      orderId
      custId
      parentOrderRef
      countryCode
      noOfGuest
      counterId
      tokenId
      externalOrderId
      aggregatorSystem
      callbackUrl
      siteId
      name
      mobile
      email
      createdBy
     reopenedAt
     syncTimestamp
      address
      address1
       custAddress {
        addressLineOne
        addressLineTwo
        locality
        city
        state
        zip
        country
      }
      date
      otp
      source
      orderFrom
      subOrderFrom
      orderEnabled
      timestamp
      taxAmt
      preparationTime
      aggregatorOrderId
      orderSource
      updatedAt
      grandTotal
      tableNo
      blockedTables
      finalAmount
      pendingOrderStatus
      orderStatus
      discountAmt
      discountType
      shippingAmount
      couponCode
      remarks
      rewardPoints
      rewardAmt
      orderCreatedFrom
      paymentMode
      paymentState
      updatedBy
      paymentStatus
      customerSegment
      rejectReason
      paidAmt
      balanceAmt
      tableOrderStatus
      isBillGenerated
      ignoreTax
      convertedCurr
      deliveryTimestamp
      qrData
      primaryWaiter
      captain
      area
      orderTags {
      tag_type
      content
      }
      rider {
        id
        name
        mobile
        status
        orderId
      }
      otherCharges{
        name
        rate
        type
        title
        tax
        taxType
        amt
        defaultSelcted
        chargesAppliedOnInclusive
      }
      taxation {
            taxType
            taxSubType
            taxRate
            taxableAmt
          }
      appliedDiscounts{
        type
        discountName
        discountType
        discountValue
        discountAmt
        note
        actionedBy
      }
      customFeilds{
        customName
        customType
        customValue
        required
        availability
      }
    
      orderList{
        subOrderId
        totalPrice
        createdAt
        createdBy
        services{
          serviceId
          masterProdId
          courseFiredAt
          itemUnit
          refId
          metaKeyword
          hsnCode
          serviceName
          serviceRate
          serviceAmount
          incentive
          discountAmt
          courseId
          discountType
          isUrgent
          uId
          pmInventory
          departmentId
          isInvWastage
          purchaseItemRef
          noDiscountItem
          costPrice
          attachedCat
          instruction
          qty
          reqQty
          tax
          taxAmt
          taxType
          itemType
          status
          station
          rejectReason
          kotId
          inprocessAt
          cancelledAt
          kotgeneratedAt
          preparedAt
          completedAt
           discounts{
           type
           discountType
           discountValue
           discountAmt
           discountName
           discountId
           note
           actionedBy
        }
        charges{
            title
            name
            rate
            type
            amt
            chargeType
            tax
            defaultSelcted
            chargesAppliedOnInclusive
        }   
          addons{
            attachedAddonCat
            isCustomQty
            serviceName
            serviceRate
            incentive
             qty
             serviceId
             tax
             station
             isInventory
             pmInventory
             departmentId
             purchaseItemRef
             noDiscountItem
             costPrice
               refId
               hsnCode
               itemUnit
           }
        }
        customFeilds{
          customName
          customType
          customValue
          required
        }
      }
    }
  }`;
  
  